<app-header></app-header>
<div class="d-flex flex-column gap48 p-24 px-48 py-40 Errorpage main-container">
  <div class="d-flex flex-column align-items-center justify-content-start justify-content-md-center gap-32 gap-32-768 h-100 position-relative">
    <img class="search-image" width="244" height="300" src="/assets/icons/er_icn_srch.svg" alt="search"/>
    @if (errorType !== 'pageNotFound') {
      <div class="content d-flex gap-16 gap-16-768 flex-column align-items-center justify-content-center">
        <h2 class="heading2 text-align heading2-768 font-bold text-black d-flex flex-column gap-16-768 gap-16">
        Oops, it looks like something went wrong</h2>
        <p class="paragraph-Medium text-align paragraph-large-768 font-open pt-6 signup-para">Please click “Try again” to sign in or sign up</p>
      </div>
    }
    @if (errorType === 'pageNotFound') {
      <div class="content d-flex gap-16 gap-16-768 flex-column align-items-center justify-content-center">
        <h2 class="heading2 text-align heading2-768 font-bold text-black d-flex flex-column gap-16-768 gap-16">
        Sorry! We couldn't find the page you were looking for.</h2>
        <p class="paragraph-Medium text-align paragraph-large-768 font-open pt-6 signup-para">The link you followed may be broken or we may have removed the page.</p>
      </div>
    }
    <div class="cta d-flex flex-column align-items-center justify-content-center">
      <a class="button round-100 round-100-768 txt-white background-red500 d-flex align-items-center justify-content-center paragraph-extra-Medium paragraph-extra-Medium-768 font-semibold border-red500 py-12 px-15 py-12-768 px-15-768"
      [routerLink]="'/'" title="Try again">Try again</a>
    </div>
  </div>
</div>